import {VALUES} from '@github-ui/issues-shared/values'
import {isPrsOnly} from '@github-ui/list-view-items-issues-prs/Query'
import {useUser} from '@github-ui/use-user'
import {Banner} from '@primer/react'
import {useMemo} from 'react'

import {MESSAGES} from '../../constants/messages'
import {useActiveSearchQuery} from '../../contexts/QueryContext'

export type MoreResultsAvailableBannerProps = {
  itemsLabel: string
}

export const MoreResultsAvailableBanner = ({itemsLabel}: MoreResultsAvailableBannerProps) => {
  const activeSearchQuery = useActiveSearchQuery()
  const {currentUser} = useUser()

  const onlyPrs = useMemo(() => isPrsOnly(activeSearchQuery), [activeSearchQuery])
  return (
    <div className="p-2">
      <Banner
        description={MESSAGES.moreItemsAvailableDescription(
          VALUES.maxIssuesListItems(onlyPrs, !!currentUser),
          itemsLabel,
        )}
        hideTitle
        title={MESSAGES.moreItemsAvailableTitle(itemsLabel)}
      />
    </div>
  )
}
